/* Account, from Account.dc.html (1440 wide). No board draws it on a phone: below 760px it takes
   PhoneLibrary.dc.html's header, 16px gutter and card look, with the nav as a row along the top. */

/* The page */
.ac-page { min-height: 100vh; display: flex; flex-direction: column; background: var(--shell-bg); }

/* The board's own header: the wordmark, Library and the initials in the gold ring */
.ac-header {
  height: 72px; display: flex; align-items: center; justify-content: space-between; gap: 24px;
  padding: 0 var(--gutter-header); border-bottom: 1px solid var(--shell-ink-10); background: var(--shell-bg);
}
.ac-header-right { display: flex; align-items: center; gap: 20px; }
.ac-header-link { font-size: 15px; font-weight: 600; color: var(--shell-ink-72); text-decoration: none; }
/* the Account board's wordmark has no letter-spacing (Main's has), as on the free pages */
.ac-header .mark--header .mark-name { letter-spacing: 0; }
.ac-header-link:hover { color: var(--shell-ink); }
.ac-initials {
  width: 44px; height: 44px; border-radius: 22px; background: var(--shell-bg); border: 1.5px solid var(--shell-gold);
  display: flex; align-items: center; justify-content: center; font-weight: 700; font-size: 15px; color: var(--shell-ink);
}

/* "Your account" and the nav on the left, the sections on the right */
.ac-body {
  flex: 1; display: grid; grid-template-columns: 220px minmax(0, 1fr); grid-template-rows: auto 1fr;
  column-gap: 64px; padding: 56px var(--gutter) 80px; align-items: start;
}
.ac-h1 { grid-column: 1; grid-row: 1; margin: 0 0 24px; font-size: 32px; font-weight: 800; line-height: 1.36; }
.ac-nav {
  grid-column: 1; grid-row: 2; display: flex; flex-direction: column; gap: 4px;
  position: sticky; top: 24px;
}
.ac-nav-link {
  padding: 10px 12px; border-radius: 8px; color: var(--shell-ink-66); text-decoration: none;
  font-weight: 600; font-size: 15px;
}
.ac-nav-link[aria-current] { color: var(--shell-ink); }
.ac-nav-link:hover { background: var(--shell-ink-04); color: var(--shell-ink); }
.ac-col { grid-column: 2; grid-row: 1 / 3; display: flex; flex-direction: column; gap: 28px; min-width: 0; }
.ac-col > section { scroll-margin-top: 24px; }
.ac-loading { min-height: 60vh; }

/* Each section */
.ac-card {
  max-width: 916px; margin-top: 12px; padding: 32px; border-radius: 16px;
  border: 1px solid var(--shell-ink-10); background: var(--shell-ink-02);
  display: flex; flex-direction: column; gap: 16px;
}
.ac-page .ac-card { max-width: none; margin-top: 0; }
.ac-card--profile { gap: 22px; }
/* the board's 72px ring of initials; Change photo beside it is hidden in phase 1 (Adam, 2 Oct) */
.ac-photo-row { display: flex; align-items: center; gap: 20px; }
.ac-photo {
  width: 72px; height: 72px; border-radius: 36px; background: var(--shell-bg); border: 2px solid var(--shell-gold);
  display: flex; align-items: center; justify-content: center; font-weight: 800; font-size: 24px; color: var(--shell-ink);
}
.ac-card--programmes { gap: 18px; }
.ac-h2 { margin: 0; font-size: 20px; font-weight: 800; }
.ac-lede { margin: 0; font-size: 16px; line-height: 1.55; color: var(--shell-ink-70); }
.ac-msg { margin: 0; font-size: 14px; line-height: 1.55; color: var(--shell-ink); }
.ac-msg--error { font-weight: 600; }
.ac-note { margin: 0; font-size: 14px; line-height: 1.55; color: var(--shell-ink-60); }

/* Fields and buttons */
.ac-form { display: flex; flex-direction: column; gap: 22px; }
.ac-grid2 { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 18px; }
.ac-field { display: flex; flex-direction: column; gap: 8px; min-width: 0; }
.ac-label { font-size: 14px; font-weight: 600; color: var(--shell-ink-72); }
.ac-input {
  width: 100%; height: 48px; padding: 0 14px; border-radius: 10px; border: 1px solid var(--shell-ink-16);
  background: var(--shell-ink-03); color: var(--shell-ink); font-size: 16px;
}
.ac-input:focus-visible { outline: 2px solid var(--shell-ink); outline-offset: 2px; }
.ac-input[readonly] { cursor: default; }
.ac-hint { font-size: 14px; color: var(--shell-ink-60); }
.ac-row { display: flex; gap: 12px; align-items: center; flex-wrap: wrap; }
.ac-row--save { gap: 14px; }
/* Logging in's line about a shared login (member review, 11 Oct): in the markup straight after Log out on
   every device, so on a phone it sits under that button and nowhere else; on a laptop, where the buttons
   share a row, it wraps onto its own line under the row, starting under that button */
.ac-row-note { order: 1; flex-basis: 100%; }
.ac-btn {
  height: 44px; padding: 0 18px; border-radius: 10px; border: 1px solid var(--shell-ink-20);
  background: transparent; color: var(--shell-ink); font-weight: 700; font-size: 14px; white-space: nowrap;
}
.ac-btn--ink { height: 46px; padding: 0 22px; border: none; background: var(--shell-ink); color: var(--shell-on-ink); font-size: 15px; }
.ac-btn:disabled, .ac-billing-btn:disabled, .ac-link:disabled { opacity: 0.55; cursor: default; }
.ac-btn[aria-busy], .ac-billing-btn[aria-busy] { opacity: 0.7; }
.ac-links { display: flex; gap: 20px; flex-wrap: wrap; }
.ac-link {
  padding: 0; border: none; background: none; color: var(--shell-ink); font-size: 14px; font-weight: 600;
  text-decoration: underline; text-underline-offset: 3px;
}

/* The email change's code step */
.ac-code {
  display: flex; flex-direction: column; gap: 10px; padding: 18px; border-radius: 12px;
  border: 1px solid var(--shell-ink-12); background: var(--shell-bg);
}
.ac-code-row { display: flex; gap: 12px; align-items: center; }
/* Login's code box (login.css .door-code): 60px tall with 28px digits (Adam, 3 Oct) */
.ac-code-input { width: 300px; height: 60px; padding: 0 18px; flex-shrink: 0; font-size: 28px; letter-spacing: 0.4em; font-weight: 700; }

/* The password form, in the same box as the email change's code step */
.ac-pw {
  display: flex; flex-direction: column; gap: 8px; max-width: 480px; padding: 18px; border-radius: 12px;
  border: 1px solid var(--shell-ink-12); background: var(--shell-bg);
}
.ac-pw .ac-row { margin-top: 6px; }

/* My programmes. The board's 300px, 200px and the rest (310px at 1440) as shares of the row, so
   the 3 columns are exactly the board's at 1440 and narrow together below it, never past the card */
.ac-table { display: flex; flex-direction: column; }
.ac-thead, .ac-trow { display: grid; grid-template-columns: minmax(0, 300fr) minmax(0, 200fr) minmax(0, 310fr); gap: 20px; }
.ac-thead {
  padding: 0 0 12px; border-bottom: 1px solid var(--shell-ink-10); font-size: 12px; font-weight: 700;
  letter-spacing: 0.12em; text-transform: uppercase; color: var(--shell-ink-60);
}
.ac-trow { padding: 16px 0; border-bottom: 1px solid var(--shell-ink-07); font-size: 15px; align-items: start; }
.ac-prog-name { display: flex; align-items: center; gap: 10px; font-weight: 700; }
.ac-prog-what { color: var(--shell-ink-72); display: flex; flex-direction: column; gap: 2px; }
.ac-prog-status { color: var(--shell-ink); font-weight: 600; }
/* a secured place's pay button, as a link under its line (member review, 11 Oct; no board draws it) */
.ac-prog-pay {
  align-self: flex-start; margin-top: 4px; padding: 0; border: none; background: none; font: inherit;
  color: var(--shell-ink); font-weight: 700; text-decoration: underline; text-underline-offset: 3px;
}
.ac-prog-pay:disabled { opacity: 0.55; cursor: default; }
.ac-prog-terms { color: var(--shell-ink-72); line-height: 1.5; }
.ac-dot { width: 9px; height: 9px; border-radius: 5px; flex-shrink: 0; box-shadow: 0 0 0 1px var(--shell-ink-20); background: var(--accent-master); }
.ac-dot--acc { background: var(--acc-green-2); }
.ac-dot--fe { background: var(--fe-green); }
.ac-dot--poyt { background: var(--poyt-orange); }
.ac-dot--pcfl { background: var(--pcfl-accent); }
.ac-dot--masterclass { background: var(--poyt-navy); }
.ac-dot--master { background: var(--shell-gold); }
/* A product's certificate, under its row (no board draws it): the number, opening the certificate
   page, and the certificate page's 2 buttons, on a light band so it reads as part of the row above */
.ac-trow--with-cert { border-bottom: none; padding-bottom: 8px; }
.ac-cert { padding: 0 0 16px; border-bottom: 1px solid var(--shell-ink-07); }
.ac-cert-cell {
  display: flex; align-items: center; justify-content: space-between; gap: 12px 20px; flex-wrap: wrap;
  padding: 12px 16px; border-radius: 10px; background: var(--shell-ink-03);
}
.ac-cert-what { display: flex; flex-direction: column; gap: 2px; font-size: 14px; min-width: 0; }
.ac-cert-label { color: var(--shell-ink-72); }
.ac-cert-link { color: var(--shell-ink); font-weight: 700; font-size: 15px; overflow-wrap: anywhere; }
.ac-cert-actions { display: flex; gap: 10px; flex-wrap: wrap; }
.ac-cert-msg { flex-basis: 100%; font-size: 14px; line-height: 1.5; color: var(--shell-ink); }
.ac-terms-link { font-size: 15px; font-weight: 600; color: var(--shell-ink); align-self: flex-start; }
.ac-table-loading { min-height: 120px; }

/* Billing (stage 2) */
.ac-billing {
  display: flex; align-items: center; justify-content: space-between; gap: 20px;
  padding: 16px 18px; border-radius: 12px; border: 1px solid var(--shell-ink-12);
}
.ac-billing-next { display: flex; flex-direction: column; gap: 4px; min-width: 0; }
.ac-billing-label { font-size: 15px; font-weight: 700; }
/* min-height: the line's own height, so the box doesn't move when the payment arrives */
.ac-billing-line { font-size: 15px; color: var(--shell-ink-70); min-height: 1.366em; }
.ac-billing-btn {
  height: 46px; padding: 0 20px; border-radius: 10px; border: none; flex-shrink: 0;
  background: var(--shell-ink); color: var(--shell-on-ink); font-weight: 700; font-size: 15px;
}
/* a balance's pay button beside Manage billing (member review, 11 Oct): the pay button is the 1 black
   button, and Manage billing gives way to an outline */
.ac-billing-actions { display: flex; gap: 10px; flex-shrink: 0; flex-wrap: wrap; justify-content: flex-end; }
.ac-billing-pay { display: inline-flex; align-items: center; justify-content: center; text-decoration: none; }
.ac-page .ac-billing-pay { color: var(--shell-on-ink); }
.ac-billing-btn--line { background: transparent; color: var(--shell-ink); border: 1px solid var(--shell-ink-20); }

/* Your data: the board's line sits under the 2 buttons */
.ac-data-msg { min-height: 0; }
.ac-export { display: flex; flex-direction: column; gap: 10px; padding-bottom: 6px; }

/* Referrals (decision 55, 13 Oct; docs/referrals-spec.md 3.5): no board draws it. The shell's look only:
   white boxes on the section's light grey, the ink for text and the 1 filled pill, greys as tints of it,
   and gold only as the small dot before Qualified, which carries no text. The faint grey is never used
   for small text. */
.ac-card--referrals { gap: 18px; }
.ac-ref-loading { min-height: 80px; }
.ac-ref-totals { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 12px; margin: 0; }
.ac-ref-total {
  display: flex; flex-direction: column; gap: 4px; min-width: 0; padding: 14px 16px; border-radius: 12px;
  border: 1px solid var(--shell-ink-10); background: var(--shell-bg);
}
.ac-ref-total dt, .ac-ref-eyebrow {
  margin: 0; font-size: 12px; font-weight: 700; letter-spacing: 0.12em; text-transform: uppercase; color: var(--shell-ink-60);
}
/* a figure never breaks over 2 lines (the review of 13 Oct: £1,234.50 did at phone width) */
.ac-ref-total dd { margin: 0; font-size: 24px; font-weight: 700; line-height: 1.25; color: var(--shell-ink); white-space: nowrap; }

.ac-ref-offer {
  display: flex; flex-direction: column; gap: 12px; padding: 20px 22px; border-radius: 12px;
  border: 1px solid var(--shell-ink-10); background: var(--shell-bg); min-width: 0;
}
.ac-ref-offer-head { display: flex; flex-direction: column; gap: 2px; }
.ac-ref-h3 { margin: 0; font-size: 18px; font-weight: 800; line-height: 1.35; }
.ac-ref-linkrow { display: flex; gap: 10px; align-items: center; flex-wrap: wrap; }
.ac-ref-input { flex: 1 1 220px; min-width: 0; height: 44px; font-size: 14px; color: var(--shell-ink-72); }
.ac-ref-btns { display: flex; gap: 10px; }
a.ac-ref-btn { display: inline-flex; align-items: center; justify-content: center; text-decoration: none; color: var(--shell-ink); }
.ac-ref-msg:empty { display: none; }
.ac-ref-note, .ac-ref-fee, .ac-ref-text { margin: 0; font-size: 15px; line-height: 1.55; color: var(--shell-ink-70); }
.ac-ref-toggle {
  align-self: flex-start; height: 36px; padding: 0 14px; border-radius: 9px; border: 1px solid var(--shell-ink-20);
  background: transparent; color: var(--shell-ink); font-weight: 700; font-size: 14px;
}
.ac-ref-details { display: flex; flex-direction: column; gap: 14px; padding-top: 14px; border-top: 1px solid var(--shell-ink-10); }
.ac-ref-positioning { margin: 0; font-size: 15px; font-weight: 700; line-height: 1.55; }
.ac-ref-part { display: flex; flex-direction: column; gap: 4px; }
.ac-ref-bullets { margin: 2px 0 0 18px; padding: 0; display: flex; flex-direction: column; gap: 4px; font-size: 15px; line-height: 1.5; color: var(--shell-ink-70); }
.ac-ref-close { margin: 0; font-size: 15px; font-weight: 700; }

.ac-ref-listbox { display: flex; flex-direction: column; gap: 6px; }
.ac-ref-list { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; }
.ac-ref-item {
  display: grid; grid-template-columns: minmax(0, 1fr) auto auto; grid-template-areas: 'name amount pill' 'meta amount pill';
  column-gap: 14px; row-gap: 2px; align-items: center; padding: 12px 0; border-bottom: 1px solid var(--shell-ink-07);
}
.ac-ref-item:last-child { border-bottom: none; }
.ac-ref-name { grid-area: name; font-size: 15px; font-weight: 700; overflow-wrap: anywhere; }
.ac-ref-meta { grid-area: meta; font-size: 14px; color: var(--shell-ink-66); }
.ac-ref-amount { grid-area: amount; font-size: 15px; font-weight: 700; }
.ac-ref-pill {
  grid-area: pill; justify-self: end; height: 28px; padding: 0 11px; border-radius: 14px; border: 1px solid var(--shell-ink-20);
  display: inline-flex; align-items: center; gap: 7px; font-size: 13px; font-weight: 700; white-space: nowrap; color: var(--shell-ink);
}
.ac-ref-pill--qualified { border-color: var(--shell-ink); }
.ac-ref-pill--qualified::before { content: ''; width: 6px; height: 6px; border-radius: 3px; background: var(--shell-gold); flex-shrink: 0; }
.ac-ref-pill--paid { background: var(--shell-ink); border-color: var(--shell-ink); color: var(--shell-on-ink); }
.ac-ref-pill--not_proceeding { border-color: transparent; padding: 0 2px; color: var(--shell-ink-60); }

/* Below 1000px (an iPad, a small laptop window) the columns would be too narrow to read, so My
   programmes stacks each row as the phone does: name, what you have, how long it lasts */
@media (max-width: 999px) {
  .ac-thead { display: none; }
  .ac-trow { grid-template-columns: minmax(0, 1fr); gap: 4px; padding: 14px 0; }
  .ac-thead + .ac-trow { padding-top: 0; }
  .ac-prog-what, .ac-prog-terms { padding-left: 19px; }
  .ac-cert-cell { flex-direction: column; align-items: stretch; }
  .ac-cert-actions { flex-direction: column; }
}

/* A phone: PhoneLibrary's 60px header and 16px gutter, the nav as a row that stays at the top. Its
   links wrap onto a 2nd line where they don't all fit (below about 550 wide), so Billing and Your data
   are never off the side (Adam's walkthrough, 9 Oct); the sideways scroll is only a last resort. */
@media (max-width: 760px) {
  .ac-header { height: 60px; padding: 0 16px; }
  .ac-header-right { gap: 14px; }
  .ac-initials { width: 40px; height: 40px; border-radius: 20px; font-size: 14px; }
  .ac-body { display: flex; flex-direction: column; align-items: stretch; padding: 0 0 8px; }
  .ac-h1 { margin: 0; padding: 22px 16px 14px; font-size: 30px; letter-spacing: -0.01em; line-height: 1.2; }
  .ac-nav {
    position: sticky; top: 0; z-index: 4; flex-direction: row; flex-wrap: wrap; gap: 6px; padding: 8px 16px;
    background: var(--shell-bg); border-bottom: 1px solid var(--shell-ink-10);
    overflow-x: auto; scrollbar-width: none; -webkit-overflow-scrolling: touch;
  }
  .ac-nav::-webkit-scrollbar { display: none; }
  .ac-nav-link {
    flex-shrink: 0; white-space: nowrap; height: 40px; display: inline-flex; align-items: center;
    padding: 0 14px; border-radius: 20px; border: 1px solid var(--shell-ink-12);
  }
  .ac-nav-link[aria-current] { border-color: var(--shell-ink); }
  .ac-col { padding: 16px 16px 0; gap: 16px; }
  /* 15px under the nav, whose height AccountNav.jsx measures (57px on 1 line, 103px on 2) */
  .ac-col > section { scroll-margin-top: calc(var(--ac-nav-h, 57px) + 15px); }

  .ac-card { padding: 22px 18px; gap: 14px; }
  .ac-card--profile, .ac-form { gap: 18px; }
  .ac-h2 { font-size: 19px; }
  .ac-lede { font-size: 15px; line-height: 1.5; }
  .ac-grid2 { grid-template-columns: minmax(0, 1fr); gap: 18px; }
  .ac-row { flex-direction: column; align-items: stretch; gap: 10px; }
  .ac-row--save { gap: 10px; }
  .ac-btn { width: 100%; height: 46px; white-space: normal; }
  .ac-row-msg:empty { display: none; }
  .ac-row-note { order: 0; flex-basis: auto; }
  .ac-pw { max-width: none; padding: 14px; }
  .ac-code { padding: 14px; }
  .ac-code-row { flex-direction: column; align-items: stretch; }
  .ac-code-input { width: 100%; }

  .ac-prog-what, .ac-prog-terms { font-size: 14px; }
  .ac-prog-terms { line-height: 1.45; }

  .ac-billing { flex-direction: column; align-items: stretch; gap: 14px; padding: 14px 16px; }
  .ac-billing-actions { flex-direction: column; }
  .ac-billing-btn { width: 100%; }

  /* Referrals at phone width: the 3 totals as 3 rows, each label on the left and its figure on the right, so a
     figure of any size stays on 1 line (a third of the width held only "£1,234.5", the review of 13 Oct); the link
     on its own line, Copy and WhatsApp side by side under it, each half the row; each referral's name and status on
     line 1, and its product, date and amount on line 2 */
  .ac-ref-totals { grid-template-columns: minmax(0, 1fr); gap: 8px; }
  .ac-ref-total { flex-direction: row; align-items: baseline; justify-content: space-between; gap: 12px; padding: 12px 16px; }
  .ac-ref-total dt { white-space: nowrap; }
  .ac-ref-total dd { font-size: 20px; }
  .ac-ref-offer { padding: 16px 14px; }
  .ac-ref-linkrow { flex-direction: column; align-items: stretch; }
  .ac-ref-input { flex: none; width: 100%; }
  .ac-ref-btns { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .ac-ref-btns .ac-btn { width: 100%; min-height: 44px; }
  .ac-ref-note, .ac-ref-fee, .ac-ref-text, .ac-ref-bullets { font-size: 14px; }
  .ac-ref-toggle { min-height: 44px; }
  .ac-ref-item { grid-template-columns: minmax(0, 1fr) auto; grid-template-areas: 'name pill' 'meta amount'; row-gap: 4px; }
  .ac-ref-amount { justify-self: end; font-size: 14px; }
}
